<template>
  <div class="sixteen wide column" style="padding-bottom:0;padding-top:1em;" v-if="isAllFormsAnswered===true">
    <div class="ui inverted small icon message mdl-card mdl-shadow--16dp" style="min-height:80%;">
      <img id="reward"
           style="max-width:70%;"></img>
      <br>
      <div class="content">
        <center>
          <div class="header">{{ localization.rewardsComponent.rewardsLine1 }}</div>
          <span>{{ localization.rewardsComponent.rewardsLine2 }}
          </span>
        </center>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeRewardsComponent',
  data: function () {
    return { }
  },
  computed: {
    // FIXME: Combine these two into one loop function to set two different properties?

    // These two props iterate through everything and if one thing is true, show one thing. if all is true, then show the line about come back later for more content.
    isAnyFormAnswered: function(){
      for (var i = 0; i < this.qnResponseOverall.length; i++) {
        if (this.qnResponseOverall[i].answered === true) {
          return true
        }
      }
      return false
    },

    isAllFormsAnswered: function(){
      for (var i = 0; i < this.qnResponseOverall.length; i++) {
        if (this.qnResponseOverall[i].answered === false) {
          return false
        }
      }
      return true
    }
  },
  methods:{
    generateRandomRewards: function(){

      let reward = [
        'DIB_confetti.png',
        'DIB_balloons.png',
        'DIB_donut.png',
        'DIB_flowers.png',
        'DIB_garland.png',
        'DIB_partyblower.png',
        'DIB_star.png',
        'DIB_2018_01_carousel.png',
        'DIB_2018_01_chameleon.png',
        'DIB_2018_01_crown.png',
        'DIB_2018_01_cupcake.png',
        'DIB_2018_01_elephant.png',
        'DIB_2018_01_giraffe.png',
        'DIB_2018_01_lion.png',
        'DIB_2018_01_parrot.png',
        'DIB_2018_01_triangles.png'
      ];

      let i = Math.floor((Math.random() * 16));

      return 'https://s3-ap-southeast-1.amazonaws.com/migraine-buddy-marketing/custombuddy/web/' + reward[i];
    }
  },
  mounted() {
    if (this.isAllFormsAnswered === true) {
      document.getElementById('reward').setAttribute('src', this.generateRandomRewards());
    }
  }
}
</script>

<style scoped>
  .mdl-card {
    border-top-left-radius:0.3em !important;
    border-radius:0.3em !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/HomeRewardsComponent.vue